<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="$emit('back')">
      <template slot="header">
        <div class="row">
          <div class="col-12 col-md-6 offset-md-3 pl-0 pr-0">
            <h5>您將指派 <span class="title-highlight">{{ titleHighlight }}</span> {{ title }}給：</h5>
          </div>

          <div class="col-12 col-md-3 pl-0 pr-0">
            <span class="btn btn-xs p-0" @click="switchOn = !switchOn">
              <img src="~../../assets/image/icon/switch_green.png" v-if="switchOn" />
              <img src="~../../assets/image/icon/switch_red.png" v-else />
            </span>
            <span :class="{ 'switch': true, 'past': switchOn }">班級清單</span>/<span :class="{ 'switch': true, 'past': !switchOn }">已選班級</span>
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item border rounded text-left mb-3"
                :class="{ 'active': getSelectedIdx(item.id) > -1 }"
                style="line-height: 150%;"
                v-for="item in groups"
                @click="assign(item)">
                <div class="float-left">
                  {{ item.name }}<br />{{ item.studentCount }} 位學生
                </div>

                <span class="float-right">
                  <icon-button name="delete" @click.native="$emit('remove', item.id)" v-if="false" />
                </span>
              </li>
            </ul>

            <pagination class="mt-3" :current="group.pageIndex" :total="group.pageCount" v-on:page="updatePage" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep">
      <template slot="header">
        <div class="row">
          <div class="col-12 col-md-6 offset-md-3 pl-0 pr-0">
            <h5>您將指派 <span class="title-highlight">{{ titleHighlight }}</span> {{ title }}給：</h5>
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2" style="font-size: 18px;">
            <span v-for="(item, index) in selected" :key="item.id">{{ index > 0 ? ',' : '' }} {{ item.name }}</span>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="3" :step="step" v-on:step="updateStep" v-on:finish="$emit('finish')">
      <template slot="header">
        <div class="row">
          <div class="col-12 col-md-6 offset-md-3 pl-0 pr-0">
            <h5>您已指派 <span class="title-highlight">{{ titleHighlight }}</span> {{ title }}給：</h5>
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2" style="font-size: 18px;">
            <span v-for="(item, index) in selected" :key="item.id">{{ index > 0 ? ',' : '' }} {{ item.name }}</span>
          </div>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import Step from './Step'
import api from '../../store/api'
import Pagination from '../../components/Pagination'
import selectMixin from './selectMixin'
import IconButton from './IconButton'

export default {

  name: 'Assign',

  components: {
    Step,
    Pagination,
    IconButton
  },

  mixins: [selectMixin],

  props: {
    titleHighlight: {
      type: String,
      required: true,
      default: ''
    },

    title: {
      type: String,
      required: true,
      default: ''
    },

    assigned: {
      type: Array,
      required: true,
      default: []
    }
  },

  data () {
    return {
      navItems: ['新增或選擇清單', '選擇班級', '確認指派', '完成'],
      step: 1,
      courseId: null,
      group: {
        list: [],
        pageIndex: 1,
        pageCount: 0
      },
      switchOn: true
    }
  },

  computed: {
    groups () {
      return this.switchOn ? this.group.list : this.selected
    }
  },

  mounted () {
    this.selected = this.assigned
    this.$emit('selected', this.selectd)
    this.getGroups()
  },

  methods: {
    updateStep (step) {
      this.step = step
    },

    updatePage (page) {
      this.getGroups(page)
    },

    async getGroups (page) {
      let params = {
        pageIndex: page || this.group.pageIndex,
        pageSize: 10
      }

      const { data } = await api.get('/GroupMgr/TeachingGroups', { params: params })

      if (data.status === 'OK') {
        this.group.list = data.data
        this.group.pageIndex = data.pageIndex
        this.group.pageCount = data.pageCount
      }
    },

    assign (item) {
      if (this.select(item)) {
        this.$emit('assign', item.id)
      } else {
        this.$emit('remove', item.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}

.title-highlight {
  color: $main-color;
}

h5 {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// Assign.vue?4a327441